import { Reveal } from "./Reveal";
import { PROCESS_STEPS } from "../../data/content";
import { ArrowDown } from "lucide-react";

export const ProcessFlow = ({ compact = false }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {PROCESS_STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 60}>
          <div className="group relative h-full rounded-xl border border-slate-200 bg-[#FAF8F1] p-6 transition-all duration-300 hover:border-gold/40 hover:bg-white/85">
            <div className="flex items-center justify-between">
              <span className="font-mono-x text-3xl font-bold text-slate-300 transition-colors group-hover:text-gold/70">{s.n}</span>
              <span className="h-2 w-2 rounded-full bg-gold/50 transition-all group-hover:bg-gold" />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold tracking-wide text-[#0B132B]">{s.name}</h3>
            {!compact && <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>}
          </div>
        </Reveal>
      ))}
    </div>
  );
};

export const VerticalTimeline = ({ steps }) => (
  <div className="mx-auto max-w-md">
    {steps.map((step, i) => (
      <Reveal key={step} delay={i * 50}>
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-center">
            <div className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/50 bg-slate-900 font-mono-x text-xs text-gold">
              {String(i + 1).padStart(2, "0")}
            </div>
            {i < steps.length - 1 && <div className="my-1 h-8 w-px bg-slate-700" />}
          </div>
          <div className="flex flex-1 items-center gap-2 pb-2">
            <span className="text-sm font-semibold text-slate-700">{step}</span>
            {i < steps.length - 1 && <ArrowDown className="h-3.5 w-3.5 text-slate-400" />}
          </div>
        </div>
      </Reveal>
    ))}
  </div>
);
